import { motion } from "framer-motion";
import { Phone, MessageSquare } from "lucide-react";
import { CONTACT } from "@/data/content";
import { trackCall } from "@/lib/analytics";

export default function MobileStickyBar({ onQuote }) {
  return (
    <motion.div
      data-testid="mobile-sticky-bar"
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 bg-[#0b1120]/95 backdrop-blur-xl border-t border-white/10 shadow-[0_-10px_30px_-15px_rgba(0,0,0,0.6)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={`tel:${CONTACT.phoneRaw}`}
        onClick={() => trackCall("sticky_bar")}
        data-testid="sticky-call-btn"
        className="flex items-center justify-center gap-2 py-4 text-white active:bg-white/10 transition-colors border-r border-white/10"
      >
        <Phone className="h-4 w-4 text-[#c9a87c]" />
        <span className="text-xs uppercase tracking-[0.18em]">Call</span>
      </a>
      <button
        onClick={onQuote}
        data-testid="sticky-quote-btn"
        className="flex items-center justify-center gap-2 py-4 bg-[#9c7a4d] text-white active:bg-[#8a6a40] transition-colors"
      >
        <MessageSquare className="h-4 w-4" />
        <span className="text-xs uppercase tracking-[0.18em]">Free Quote</span>
      </button>
    </motion.div>
  );
}
